
import { SetupContext } from 'vue'
import { HTMLElementEvent } from '@/types/HTMLElement'

export default {
  name: 'InputRadioButton',

  props: {
    id: String,
    label: String,
    name: String,
    error: {
      type: Boolean,
      default: false
    },
    req: {
      type: Boolean,
      default: false
    },
    value: String,
    currentValue: String
  },

  setup(props: any, context: SetupContext) {
    const callInputChange = (e: HTMLElementEvent<HTMLInputElement>) => {
      context.emit('call-input-change', e.target.value)
    }

    return {
      callInputChange
    }
  }
}
